import { createContext } from 'react'

export const defaultContext = {
  getNotificationContacts: (() => {}) as () => Promise<void>,
  notificationContacts: [] as INotificationContact[],
  doNotContactContacts: [] as INotificationContact[],
}

const ContactsContext = createContext(defaultContext)

export default ContactsContext
